import { gql } from '@apollo/client';

export const GET_GYMS = gql`
  query GET_GYMS(
    $location: GeolocationInput!
    $sector: String
    $serviceSector: String!
    $sortBy: String
    $isAdminPortal: Boolean
    $product: String
  ) {
    locationBasedFacilityOfferings(
      location: $location
      serviceSector: $serviceSector
      sector: $sector
      sortBy: $sortBy
      isAdminPortal: $isAdminPortal
      product: $product
    ) {
      facilityId
      name
      location {
        latitude
        longitude
        address
        city
        state
        zipcode
      }
      imageUrl
      phoneNumber
      note
      website
      premium
      authTags {
        key
        name
      }
      startsAtTier {
        name
      }
    }
  }
`;
